<template>
  <div class='coursework-viewer__info-bar'>
    <a class='coursework-viewer__hide-toggle' href="javascript:;" @click="toggleFullView">
      <div class='coursework-viewer__tour2-target'></div>
      <span v-if="!isFullView">Show</span>
      <span v-if="isFullView">Hide</span>
    </a>
    <div class='coursework-viewer__info-bar_contents'>
      <div class='coursework-viewer__project-info'>
        <div class='coursework-viewer__student-info_avatar'>
          <img v-bind:src="author.avatar">
        </div>
        <div class='coursework-viewer__student-info'>
          <div class='coursework-viewer__student-info_name--mobile' v-tabkeyfocus="true">{{author.name}}</div>
          <a class='coursework-viewer__student-info_name' href="javascript:;" @click="toggleCarousel">
            <span>{{author.name}}</span>
            <i v-if="hasCarousel" class='kf kf-arrow-thin'></i>
            <div class='coursework-viewer__tour3-target'></div>
          </a>
          <div>
            <a class='coursework-viewer__project-info_about' href="javascript:;" @click="toggleDescription" v-tabkeyfocus="true">About {{work.type}}</a>
          </div>
          <a class='coursework-viewer__project-info_about--mobile' href="javascript:;" @click="toggleDescription">
            <span class='kf-stack kf-stack--circle'>
              <i class='kf kf-circle-fill'></i>
              <i class='kf kf-inverse kf-info'></i>
            </span>
          </a>
        </div>
      </div>
      <div class='coursework-viewer__display-state'>
        <a href="javascript:" class='coursework-viewer__display-toggle' v-if="media && media.comments_path" @click="showViewer" :class="{'is-selected': isPreviewMode}" v-tooltip="{ content: 'Browse', position: 'top'}" v-tabkeyfocus="true">
          <i class='kf kf-eye'></i>
        </a>
        <a href="javascript:" class='coursework-viewer__display-toggle' v-if="media && media.comments_path" @click="toggleComments" :class="{'is-selected': isCommentMode}" v-tooltip="{ content: 'Comment', position: 'top'}" v-tabkeyfocus="true">
          <i class='kf kf-comment'></i>
          <span class='kd-badge kd-badge__offset-top' v-if="media.comment_count > 0">{{media.comment_count}}</span>
        </a>
        <a href="javascript:" class='coursework-viewer__display-toggle' v-if="false" v-tabkeyfocus="true" v-tooltip="{ content: 'Code', position: 'top'}">
          <i class='kf kf-file-code'></i>
        </a>
      </div>
      <div class='coursework-viewer__additional-actions'>
        <div class='coursework-viewer__tour5-target'></div>
        <a :href="media.download_path" target="_blank" class='kd-ibtn kf-ibtn--bg-dark' v-if="media && media.download_path" v-tooltip="{content: 'Download', position: 'top'}">
          <i class='kf kf-download'></i>
        </a>
        <a href="javascript:;" class='kd-ibtn kf-ibtn--bg-dark' @click="toggleFavorite" v-if="work.favouritable" v-tooltip="{content: 'Like', position: 'top'}">
          <i class='kf kf-heart-outline'></i>
          <span class='kd-badge kd-badge__offset-top'>{{work.favouritable.count}}</span>
        </a>
        <a href="javascript:;" class='kd-ibtn kf-ibtn--bg-dark' @click="share" v-if="work.shareable" v-tooltip="{content: 'Share', position: 'top'}">
          <i class='kf kf-share'></i>
        </a>
      </div>
    </div>      
  </div>
</template>

<script>
  export default {
    props: {
      hasCarousel: Boolean,
      author: Object,
      work: Object,
      media: Object
    },
    data() {
      return {
        
      }
    },
    computed: {
      isFullView() {
        return this.$parent.show_full_view
      },
      isPreviewMode() {
        return !this.$parent.show_comments
      },
      isCommentMode() {
        return this.$parent.show_comments
      }
    },
    methods: {
      toggleFullView() {
        this.$emit('toggleFullView')
      },
      toggleDescription() {
        this.$emit('toggleDescription')
      },
      toggleComments() {
        this.$emit('toggleComments')
      },
      toggleCarousel() {
        this.hasCarousel && this.$emit('toggleCarousel')
      },
      toggleFavorite() {
        this.$emit('toggleFavorite')
      },
      showViewer() {
        this.$emit('showViewer')
      },
      share() {
        this.$emit('showShareModal')
      }
    }
  }
</script>